import React,{useState,useEffect,useCallback} from 'react'
import Card from '../home/Card'
import { modalToggle } from 'redux/actions/general'
import { useDispatch,useSelector } from 'react-redux'
import ChevronWhite from 'assets/icon/chevron-white.png'
import Chevron from 'assets/icon/chevron.png'
import SearchRed from 'assets/icon/search-red.png'
import { setReducer } from 'redux/actions/reducer'
import { getSearch,getForumFilter,postForumAction,deleteDiskusi,getForumDetailBySlug } from 'redux/actions/forum'
import { setPersist } from 'redux/actions/persist'
import LoadingCard from '../LoadingCard'
import EmptyBeranda from 'assets/image/empty-beranda.png'
import { debounce } from 'lodash'
import { setLoadingComment } from 'redux/actions/general'
export default function Beranda() {
    const dispatch = useDispatch()
    const [sort, setsort] = useState('terbaru')
    const [option, setoption] = useState({})
    const [opencomment, setopencomment] = useState({})
    const [test, settest] = useState({})
    const debounceLoadData = useCallback(debounce(fetchData, 1000), []);
    const general = useSelector(state => state.general)
    const reducer = useSelector(state => state.reducer)
    const persist = useSelector(state => state.persist)
    let {search,beranda,search_list,filter_search}=reducer
    let {forum_sort,forum_auth}=persist
    let params=new URLSearchParams(window.location.search)
    let q=params.get('q')
    
    useEffect(() => {
        if(beranda===null){
            dispatch(setReducer({search:q}))
            dispatch(getForumFilter())
            dispatch(getSearch(`/${forum_sort}/${convertHash(q)}`))
        }
        // console.log('from useeffect')
        if(beranda!==null){
            debounceLoadData(search);

        }
    }, [search])
    // console.log(`beranda`, search_list)
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    const sortToggle=(key)=>{
        dispatch(setPersist({forum_sort:key}))   
        dispatch(getSearch(`/${key}/${convertHash(q)}`))
    }
    function fetchData(filter) {
        
        let convert=filter.replace('#','%23')
        dispatch(getSearch(`/${forum_sort}/${convert}`))
    }
    
    
    
    const addDiskusi=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Buat Diskusi",
            modal_component: "add_diskusi",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'add_diskusi',
        }))
    }
    const addFilter=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "filter_search",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'filter_search',
        }))
    }
    const addSortir=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Sortir",
            modal_component: "sortir",
            modal_size:590,
            modal_type:'',
            modal_data:{actionSort:(key)=>sortToggle(key)},
            modal_action:'sortir',
        }))
    }
    const showSearch=()=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Cari berdasarkan tag",
            modal_component: "search",
            modal_size:590,
            modal_type:'',
            modal_data:null,
            modal_action:'search',
        }))
    }
    const renderSort=()=>{
        switch (forum_sort) {
            case 1:
                return 'Terbaru'
            case 2:
                return 'Termenarik'
            case 3:
                return 'Terjawab'
            case 4:
                return 'Belum Terjawab'
            default:
                break;
        }
    }
    const onClickVote=(data,i,i2)=>{
        if(forum_auth.canVote){
            search_list[i].items[i2].nvote=search_list[i].items[i2].isVoted===false?search_list[i].items[i2].nvote+1:search_list[i].items[i2].nvote
            search_list[i].items[i2].isVoted=true
            dispatch(setReducer({search_list:search_list}))
            dispatch(postForumAction(`/vote/${data.id}`))
        }
        
    }
    const flagAction=(data,i,i2)=>{
        search_list[i].items[i2].nflag=search_list[i].items[i2].isFlag===false?search_list[i].items[i2].nflag+1:search_list[i].items[i2].nflag
        search_list[i].items[i2].isFlag=true
        dispatch(setReducer({search_list:search_list}))
        dispatch(postForumAction(`/flag/${data.id}`))
        return data
    }
    const onClickFlag=(data,i,i2)=>{
        if(forum_auth.canFlag){
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "",
                modal_component: "delete_diskusi",
                modal_size:400,
                modal_type:'delete',
                modal_data:{
                    actionDelete:()=>flagAction(data,i,i2),
                    getAction:()=>null,
                    data,
                    title:' Laporkan Postingan Ini',
                    desc:'Postingan ini mengandung unsur yang tidak relevan dengan forum diskusi, laporkan postingan ini untuk ditinjau oleh tim kami dan akan dihapus jika memang merupakan postingan yang tidak relevan.',
                    btn_delete:'Laporkan'
                },
                modal_action:'delete_diskusi',
            }))
        }
        
    }
    const onClickMore=(data,i)=>{
        search_list[i].is_more=true
        dispatch(setReducer({search_list:search_list}))
    }
    const editDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "Edit Diskusi",
            modal_component: "add_diskusi",
            modal_size:590,
            modal_type:'',
            modal_data:{getAction:()=>dispatch(getSearch(`/${forum_sort}/${convertHash(q)}`)),data},
            modal_action:'edit_diskusi',
        }))
    }
    const optionToggle=(data,i)=>{
        setoption({...option,[i]:!option[i]})
    }
    const onDeleteDiskusi=(data,i)=>{
        dispatch(modalToggle({ 
            modal_open: true,
            modal_title: "",
            modal_component: "delete_diskusi",
            modal_size:400,
            modal_type:'delete',
            modal_data:{
                actionDelete:()=>dispatch(deleteDiskusi(data.id)),
                getAction:()=>dispatch(getSearch(`/${forum_sort}/${convertHash(q)}`)),
                data,
                title:' Hapus Postingan Diskusi',
                desc:'Postingan diskusi mu akan di hapus dari sistem',
                btn_delete:'Hapus Postingan'
            },
            modal_action:'delete_diskusi',
        }))
    }
    const SearchItem=({data,i})=>{
        return(
            <div>
                <div className='search-category' key={i}>
                    <h2 className='font-nunito margin-0'>{data.channel}</h2>
                </div>
                {data.items.map((item,i2)=>{
                    if(data.is_more){
                        return(
                            <Card 
                                key={i2}
                                data={item}
                                index={i2}
                                onClickVote={()=>onClickVote(item,i,i2)}
                                onClickFlag={()=>onClickFlag(item,i,i2)}
                                forum_auth={forum_auth}
                                optionToggle={optionToggle}
                                option={option}
                                editDiskusi={editDiskusi}
                                deleteDiskusi={onDeleteDiskusi}
                                opencomment={opencomment}
                                openCommentToggle={openCommentToggle}
                            />  
                        )
                    }else{

                        if(i2<3){
                            return(
                                <Card 
                                    data={item}
                                    index={i2}
                                    onClickVote={()=>onClickVote(item,i,i2)}
                                    onClickFlag={()=>onClickFlag(item,i,i2)}
                                    forum_auth={forum_auth}
                                    key={i2}
                                    optionToggle={optionToggle}
                                    option={option}
                                    editDiskusi={editDiskusi}
                                    deleteDiskusi={onDeleteDiskusi}
                                    opencomment={opencomment}
                                    openCommentToggle={openCommentToggle}
                                />  
                            )
                            
                        }
                    }
                    
                    
                })}
                {!data.is_more&&<div className='div-flex div-justify-center'>
                    <div className='more-container' onClick={()=>onClickMore(data,i)}>
                        <p className='font-nunito margin-0'>Lihat lebih banyak</p>
                    </div>
                </div>}
            </div>
        )
    }
    const openCommentToggle=async (data,i)=>{
        setopencomment({...opencomment,[i]:!opencomment[i]})
        await dispatch(getForumDetailBySlug(`/${1}/${1}/${50}/${data.slug}`))
    }
    return (
        <div>
            <div className='fix-menu-beranda'>
                <div className='menu-beranda-desktop'>
                    <div className=' seach-container div-flex div-justify-between div-align-center'>
                        <a href='/forum'><div className='chevron-back'>
                            <img src={ChevronWhite}/>
                        </div></a>
                        <input value={search} onChange={(e)=>dispatch(setReducer({search:e.target.value}))} className='search-icon' autoFocus/>
                    </div>
                    <div className='beranda-info div-flex div-justify-between div-align-center'>
                        <p className='font-nunito amount-diskusi margin-0'>{beranda!==null&&beranda.items.length} Diskusi</p>
                        <div className='beranda-sort'>
                            <div className={`beranda-sort-item ${forum_sort===1&&'beranda-sort-active'}`} onClick={()=>sortToggle(1)}>
                                <p className='font-nunito margin-0'>Terbaru</p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===2&&'beranda-sort-active'}`} onClick={()=>sortToggle(2)}>
                                <p className='font-nunito margin-0'>Termenarik</p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===3&&'beranda-sort-active'}`} onClick={()=>sortToggle(3)}>
                                <p className='font-nunito margin-0'>Terjawab <span>{beranda!==null&&beranda.countTerjawab!==0&&`(${beranda.countTerjawab})`}</span></p>
                            </div>
                            <div className={`beranda-sort-item ${forum_sort===4&&'beranda-sort-active'}`} onClick={()=>sortToggle(4)}>
                                <p className='font-nunito margin-0'>Belum Terjawab <span>{beranda!==null&&beranda.countBelumTerjawab!==0&&`(${beranda.countBelumTerjawab})`}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className='beranda-hr'></div>
                </div>
                <div className='menu-beranda-mobile'>
                <div className='beranda-mobile-head seach-container div-flex div-justify-between div-align-center'>
                        <a href='/forum'><div className='chevron-back'>
                            <img src={ChevronWhite}/>
                        </div></a>
                        <input value={search} onChange={(e)=>dispatch(setReducer({search:e.target.value}))} className='search-icon'/>
                    </div>
                    
                    <div className='div-flex div-justify-between beranda-mobile-info'>
                        <div className='div-flex div-align-center'>
                            <p className='font-nunito margin-0'>Sortir : {renderSort()}</p>
                            &nbsp;&nbsp;&nbsp;
                            <img onClick={addSortir} src={Chevron} className='chevron-mobile-sort'/>
                        </div>
                        <div className='div-flex div-align-center'>
                            
                            <p onClick={addFilter} className='font-roboto margin-0 font-bold' style={{color:'#ff4e4e'}}>Filter</p>
                        </div>
                    </div>
                    <div className='beranda-hr'></div>

                </div>
                
            </div>
            <div className='card-container'>
                {general.isLoadingBeranda&&
                    <>
                        <LoadingCard/>
                    </>
                }
                {!general.isLoadingBeranda&&search_list.length<1&&
                <div style={{textAlign:'center',height:500}}>
                    <img src={EmptyBeranda} className='empty-beranda'/>
                    <h2 className='font-roboto'>Belum ada diskusi, {forum_auth.canPost&&<>ayo <span onClick={addDiskusi} style={{color:'#ff4e4e',cursor:'pointer'}}>Buat Diskusi</span></>}</h2>
                </div>
                }
                {search_list.map((data,i)=>{
                    if(filter_search!==0){
                        if(filter_search===data.channelId){
                            return <SearchItem data={data} i={i}/>
                        }
                    }else{
                        return <SearchItem data={data} i={i}/>
                    }
                    
                })}
                
                

            </div>
           
        </div>
    )
}
